<!--
� 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
-->

<section class="page">
	<div class="page-header">
		<div class="back">
			<globalictcc-button
				label="Back to Anomalies detection"
				[textOnly]="true"
				iconName="arrow-left"
				(handleClick)="onGoBack()"
			/>
		</div>

		<div class="page-title">
			<span class="page-name">{{ applicationName }}</span>
		</div>
	</div>

	<div class="filter-pagination">
		<globalictcc-popover>
			<globalictcc-button
				popover-trigger
				label="Filter"
				[textOnly]="true"
				iconName="filter"
			/>

			<form
				popover-template
				[formGroup]="filterFormGroup"
				class="popover-content"
			>
				<span class="popover-title">Filter</span>

				<globalictcc-dropdown
					label="Type"
					class="fill"
					formControlName="types"
					[multi]="true"
					[options]="typeOptions"
				/>

				<globalictcc-dropdown
					label="Layer"
					formControlName="layers"
					[multi]="true"
					[options]="layerOptions"
					[paginated]="true"
					[hasMore]="hasMoreLayers"
					[isLoadingMore]="isLayersLoadingMore"
					(loadMore)="onLayerLoadMore()"
				/>

				<globalictcc-button
					label="Apply"
					[disabled]="filterFormGroup.invalid"
					type="submit"
					(handleClick)="onFilterApply()"
				/>
			</form>
		</globalictcc-popover>

		<globalictcc-pagination
			[currentPage]="currentPage"
			[totalItems]="totalItems"
			[pageSize]="pageSize"
			[totalPages]="totalPages"
			[pageItems]="pageItems"
			(handlePreviousPage)="onPreviousPage()"
			(handleNextPage)="onNextPage()"
		/>
	</div>

	<globalictcc-table
		[gridOptions]="gridOptions"
		[hasError]="anomaliesDetailsTableHasError"
		(handleTableRefresh)="fetchApplicationAnomalies()"
	/>

	<div class="charts">
		<globalictcc-chart
			chartType="line"
			[data]="sciLineChart?.chart"
			[isLoading]="isSciLineChartLoading"
			[hasError]="sciLineChart?.hasError"
			[configOverrides]="sciOverrides"
			(handleChartRefresh)="fetchApplicationAnomalies()"
		/>

		<globalictcc-chart
			chartType="line"
			[data]="co2LineChart?.chart"
			[isLoading]="isCo2LineChartLoading"
			[hasError]="co2LineChart?.hasError"
			[configOverrides]="co2Overrides"
			(handleChartRefresh)="fetchApplicationAnomalies()"
		/>

		<globalictcc-chart
			chartType="line"
			[data]="sciComponentELineChart?.chart"
			[isLoading]="isSciComponentELineChartLoading"
			[hasError]="sciComponentELineChart?.hasError"
			[configOverrides]="sciComponentEOverrides"
			(handleChartRefresh)="fetchApplicationAnomalies()"
		/>
	</div>
</section>
